module.exports = __webpack_public_path__ + "static/media/kendrafoundit-IG-6.f171a568.PNG";